export const formatPrice = (str: string, digits?: boolean) => {
    const decimals = digits ? 2 : 0;
    const numberDk = str.replace(/[^0-9,-]/g, '');
    const numberInt = parseFloat(numberDk.replace(',', '.'));

    const number = new Intl.NumberFormat('da-DK', {
        maximumFractionDigits: decimals,
        minimumFractionDigits: decimals,
    }).format(numberInt);

    if (number === 'NaN') return '';

    return number;
};
